module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-music-fill-e998d324.svg";